import { createFileRoute } from '@tanstack/react-router'

import { SanteclairPageSkeleton } from '#/modules/health/front-office/santeclair-page/santeclair-page-skeleton.tsx'
import { SanteclairPage } from '#/modules/health/front-office/santeclair-page/santeclair-page.tsx'

export const Route = createFileRoute('/(customer)/_shell/health-insurance-v2/santeclair')({
  pendingComponent: SanteclairPageSkeleton,
  pendingMs: 150,
  component: SanteclairPage,
})
